import React from "react";
import styled from "styled-components";
import {
  SiCodechef,
  SiLeetcode,
  SiCodingninjas,
  SiGeeksforgeeks,
} from "react-icons/si";
import { Bio } from "../../data/constants";
import { FaEye } from "react-icons/fa";

// Styled components

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin-right: 1rem;
  font-size: 3rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.3s ease, transform 0.3s ease;
  &:hover {
    color: ${({ theme }) => theme.primary};
    transform: scale(1.1);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  background-color: ${({ theme }) => theme.background};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 1rem 2rem;
  gap: 30px;
`;

const ProfileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column; /* Stack vertically on small screens */
  }
`;

const ProfileRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem; /* Space between icon and text */
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column; /* Stack icon and text vertically on small screens */
    align-items: flex-start;
  }
`;

const Title = styled.h2`
  font-size: 36px;
  text-align: center;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 650px;
  line-height: 1.6;
  margin-top: 5px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CertificationTable = styled.table`
  width: 100%;
  max-width: 900px;
  margin-top: 30px;
  border-collapse: collapse;
  text-align: left;
  background-color: ${({ theme }) => theme.card};
  border-radius: 8px;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
`;

const TableHeader = styled.th`
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.text_primary};
  border: 1px solid ${({ theme }) => theme.text_secondary};
`;

const TableData = styled.td`
  padding: 12px;
  font-size: 16px;
  color: ${({ theme }) => theme.text_secondary};
  border: 1px solid ${({ theme }) => theme.text_secondary};
  a {
    color: ${({ theme }) => theme.text_primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

// Contact Component

const Contact = () => {
  return (
    <>
      <Container>
        <Wrapper>
          <Title>Coding Profiles</Title>

          <ProfileWrapper>
            <div>
              <ProfileRow>
                <SocialMediaIcon href={Bio.leetcode} target="display">
                  <SiLeetcode color="yellow" />
                </SocialMediaIcon>
                <Desc>Solved 480+ Questions</Desc>
              </ProfileRow>

              <ProfileRow>
                <SocialMediaIcon href={Bio.codechef} target="display">
                  <SiCodechef color="yellow" />
                </SocialMediaIcon>
                <Desc>Participated in 20+ contests (Highest Rating 1421).</Desc>
              </ProfileRow>
            </div>

            <div>
              <ProfileRow>
                <SocialMediaIcon href={Bio.codingninja} target="display">
                  <SiCodingninjas color="yellow" />
                </SocialMediaIcon>
                <Desc>Solved 330+ Questions.</Desc>
              </ProfileRow>

              <ProfileRow>
                <SocialMediaIcon href={Bio.geeksforgeeks} target="display">
                  <SiGeeksforgeeks color="yellow" />
                </SocialMediaIcon>
                <Desc>Solved 240+ Questions.</Desc>
              </ProfileRow>
            </div>
          </ProfileWrapper>
        </Wrapper>
      </Container>

      <Container>
        {/* Certifications Section */}
        <Wrapper>
          <Title>Certifications</Title>

          {/* Certification Table */}
          <CertificationTable>
            <thead>
              <tr>
                <TableHeader>Certification</TableHeader>
                <TableHeader>Link</TableHeader>
              </tr>
            </thead>
            <tbody>
              <tr>
                <TableData>
                  The Complete 2023 Web Development Bootcamp by Dr. Angela Yu
                </TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/file/d/1nd_vcCSYmfNoXveksB6qATbUPlzpjn4H/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>The Complete Node.js Developer Course</TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/file/d/1TowKRiArNqjtTOP45FVQJKIaVT_UiKGT/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>
                  Ultimate AWS Certified Developer Associate 2023 NEW DVA-C02 by
                  Stephane Maarek
                </TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/file/d/13jYqRbsN1xxHA4MytN5PZiFBif9C23Xs/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>
                  AWS Cloud with AI Workshop by Mr. Vimal Daga
                </TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/file/d/1YqD1giVw4rt9FS7xxdmWbDT-hdhUgqBo/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>Networking by Cisco</TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/drive/folders/1bSgifU-jqq1DEh7faTIg-qdHmB35ziQk"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>Cybersecurity by Cisco</TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/drive/folders/1KCviRaSro4_kATgjXg_WoAbbXD2GgrUs"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
              <tr>
                <TableData>Python by Cisco</TableData>
                <TableData>
                  <a
                    href="https://drive.google.com/drive/folders/1Npvlitybuqh5JGy6CoOkMvNDFhA1q3sp"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaEye />
                  </a>
                </TableData>
              </tr>
            </tbody>
          </CertificationTable>
        </Wrapper>
      </Container>
    </>
  );
};

export default Contact;
